define('views/blocks/checkout/PaymentModeSelectionView',['underscore', 'backbone', 'jquery', 'app', 'SubView',
    'views/blocks/checkout/PaymentModeSelectionModalView',
    'template!blocks/checkout/payment-mode-selection-button'
], function (_, Backbone, $, app, SubView,
             PaymentModeSelectionModalView,
             templateButton
     ){
    var checkoutModel;
    return Backbone.View.extend(SubView).extend({
        events:{
          'click button':'displaySelectionModal'
        },
        initialize:function(options){
            checkoutModel = options.checkoutModel;
            var view = this;
            view.listenTo(checkoutModel,'change:id_payment_mode',view.onChange);
            view.listenTo(app,'changePaymentModeParams',view.onChange);
            view.listenTo(app,'requirePaymentModeSelection',view.displaySelectionModal);
        },
        onChange:function(){
            var view = this;
            view.$el.html(templateButton(checkoutModel.getPaymentModeSelectionOptions()));
        },
        displaySelectionModal:function(){
            var modalView = new PaymentModeSelectionModalView({checkoutModel:checkoutModel});
            app.displayModal(modalView);
        }
    });
});

